import { PureComponent, Fragment } from 'react';

// COMPONENTS
import MaybeTranslation from 'components/MaybeTranslation';

// STYLES
import { TooltipPointer, TooltipWrapper } from './Tooltip.styles';

export const Tooltip = (props) => (
  <Fragment>
    <TooltipWrapper key="wrapper">
      <MaybeTranslation renderedValue={props.renderedValue} />
    </TooltipWrapper>
    <TooltipPointer key="pointer" />
  </Fragment>
);

export default function withTooltip(UnwrappedComponent) {
  class WithTooltip extends PureComponent {
    static defaultProps = {
      suppressTooltip: false,
    };

    state = {
      showTooltip: false,
    };

    handleMouseOver = () => {
      this.setState({
        showTooltip: true,
      });
    };

    handleMouseOut = () => {
      this.setState({ showTooltip: false });
    };

    render() {
      // @ts-expect-error TS(2339): Property 'suppressTooltip' does not exist on type ... Remove this comment to see the full error message
      const { suppressTooltip, ...rest } = this.props;
      return (
        <UnwrappedComponent
          {...rest}
          onMouseOver={this.handleMouseOver}
          onFocus={this.handleMouseOver}
          onMouseOut={this.handleMouseOut}
          onBlur={this.handleMouseOut}
        >
          {/* @ts-expect-error TS(2339): Property 'tooltip' does not exist on type 'Readonl... Remove this comment to see the full error message */}
          {this.state.showTooltip && !suppressTooltip && <Tooltip renderedValue={this.props.tooltip} />}
        </UnwrappedComponent>
      );
    }
  }

  return WithTooltip;
}
